import { render, staticRenderFns } from "./LabelValue.vue?vue&type=template&id=5800b71d&scoped=true&"
import script from "./LabelValue.vue?vue&type=script&lang=js&"
export * from "./LabelValue.vue?vue&type=script&lang=js&"
import style0 from "./LabelValue.vue?vue&type=style&index=0&id=5800b71d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5800b71d",
  null
  
)

export default component.exports